function generateBorder(style, isImportant) {
    if (style) {
        const currentBorder = style.border ? style.border : "";
        const addImportant = isImportant ? '!important' : '';
        return {
            borderTop: `${currentBorder.split(" ")[0] || 0} solid ${addImportant}`,
            borderRight: `${currentBorder.split(" ")[1] || 0} solid ${addImportant}`,
            borderBottom: `${currentBorder.split(" ")[2] || 0} solid ${addImportant}`,
            borderLeft: `${currentBorder.split(" ")[3] || 0} solid ${addImportant}`
        }
    }
    return {}
}

export {generateBorder}